import React from 'react';

import ManualBillEditContainer from '../../../bills/components/create/ManualBillEditContainer';
import { BillContext } from '../../../bills/types/Bill';

export default function ManualReviewBillEditScreen() {
    return <ManualBillEditContainer context={BillContext.REVIEW} />;
}
